import React from "react";
import Slider from "../components/Slidbar/Slidbar";
import Tabel from "../components/Seeker/Tabel";

export const Seeker = () => {
  return (
    <>
      <Slider />
      <Tabel />
    </>
  );
};
